import { render, staticRenderFns } from "./SpacementInput.vue?vue&type=template&id=8a45e07e&"
import script from "./SpacementInput.vue?vue&type=script&lang=js&"
export * from "./SpacementInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports